import React, { Fragment } from 'react'
import useStyles from './styles'
import { Box, Chip, Typography } from '@material-ui/core'
import { formatMoney } from 'accounting'
import TextClamp from 'react-string-clamp'
import useNameStyle from 'hooks/useNameStyle'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { getItemBids } from 'actions/items'
import { isEmpty } from 'lodash'
import EventNoun from 'components/EventNoun'

const AmountBanner = ({ item, donationAmount = 0, donateMode }) => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const bidIds = useSelector(state => state.items.bidIds)
  const auctionFormat = useSelector(state => state.event.event.auction_format)
  let styledName = ''
  styledName = useNameStyle(
    !isEmpty(item) ? item.high_bid_data.high_bid_user_name : ''
  )
  if (
    item.hasOwnProperty('high_bid_data') &&
    item.high_bid_data.hasOwnProperty('high_bid_anon')
  ) {
    if (
      item.high_bid_data.high_bid_anon === '1' ||
      item.high_bid_data.high_bid_anon === 1
    ) {
      styledName = 'Anonymous'
    }
  }

  useEffect(() => {
    if (!isEmpty(item) && isEmpty(bidIds)) {
      dispatch(getItemBids(item.item_id))
    }
  }, [])

  return (
    <Box className={classes.amountBanner}>
      {!donateMode &&
        !isEmpty(item) &&
        item.item_type === 'auction' &&
        !isEmpty(item.high_bid_data) && (
          <Typography className={classes.amountBannerTypography}>
            Lead Bid
          </Typography>
        )}
      <Box display="flex" justifyContent="space-between">
        {!isEmpty(item) && !donateMode && (
          <Fragment>
            {item.item_type === 'auction' && (
              <Fragment>
                {isEmpty(item.high_bid_data) && (
                  <Typography variant="h3" className={classes.bidderName}>
                    Starting Bid : ${item.reserve}
                  </Typography>
                )}
                {!isEmpty(item.high_bid_data) && (
                  <Fragment>
                    {styledName === 'paddle_number' &&
                      item.item_type === 'auction' && (
                        <Chip
                          className={classes.chip}
                          color="primary"
                          label={bidIds[item.high_bid_data.high_bid_user_id]}
                        />
                      )}
                    <Typography variant="h3" className={classes.bidderName}>
                      <TextClamp
                        text={styledName === 'paddle_number' ? '' : styledName}
                        lines={1}
                      />
                    </Typography>
                    <Typography variant="h3" className={classes.bidAmount}>
                      {formatMoney(item.high_bid, '$', 0)}
                    </Typography>
                  </Fragment>
                )}
              </Fragment>
            )}
            {item.item_type !== 'auction' && (
              <Fragment>
                {!item.item_sales && (
                  <Typography variant="h3" className={classes.bidderName}>
                    {`${auctionFormat === 10 ? 'Vote' : 'Buy'}`} Now
                  </Typography>
                )}
                {item.item_sales && (
                  <Fragment>
                    <Typography variant="h3" className={classes.bidderName}>
                      Total Raised
                    </Typography>
                    <Typography variant="h3" className={classes.bidAmount}>
                      {formatMoney(item.item_sales, '$', 0)}
                    </Typography>
                  </Fragment>
                )}
              </Fragment>
            )}
            {/* {!isEmpty(item.high_bid_data) && (
              <Fragment>
                {styledName === 'paddle_number' &&
                  item.item_type === 'auction' && (
                    <Chip
                      className={classes.chip}
                      color="primary"
                      label={bidIds[item.high_bid_data.high_bid_user_id]}
                    />
                  )}
                <Typography variant="h3" className={classes.bidderName}>
                  {item.item_type === 'auction' ? (
                    <TextClamp
                      text={styledName === 'paddle_number' ? '' : styledName}
                      lines={1}
                    />
                  ) : (
                    'Total Raised'
                  )}
                </Typography>
                <Typography variant="h3" className={classes.bidAmount}>
                  {formatMoney(
                    item.item_type === 'auction'
                      ? item.high_bid
                      : item.item_sales,
                    '$',
                    0
                  )}
                </Typography>
              </Fragment>
            )}
            {item.item_type === 'auction' && isEmpty(item.high_bid_data) && (
              <Typography variant="h3" className={classes.bidderName}>
                Bid Now
              </Typography>
            )}
            {item.item_type !== 'auction' && (
              <Typography variant="h3" className={classes.bidderName}>
                {`${auctionFormat === 10 ? 'Vote' : 'Buy'}`} Now
              </Typography>
            )} */}
          </Fragment>
        )}
        {(isEmpty(item) || donateMode) && (
          <Fragment>
            <Typography variant="h3" className={classes.bidderName}>
              Total Raised
            </Typography>
            <Typography variant="h3" className={classes.bidAmount}>
              {formatMoney(donationAmount, '$', 0)}
            </Typography>
          </Fragment>
        )}
      </Box>
    </Box>
  )
}

export default AmountBanner



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/AmountBanner/index.jsx